import React, { useState } from "react";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [submitStatus, setSubmitStatus] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/contact-us", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus(
          "Thank you for your message! We have received your inquiry."
        );
        setIsSubmitted(true);
      } else {
        const errorText = await response.text();
        setSubmitStatus(`Failed to send message: ${errorText}`);
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmitStatus("An error occurred. Please try again later.");
    }
  };

  return (
    <div>
      {isSubmitted ? (
        <div
          style={{
            position: "fixed",
            top: "10%",
            left: "47%",
            transform: "translateX(-50%)",
            padding: "20px",
            backgroundColor: "#d4edda",
            color: "#155724",
            border: "1px solid #c3e6cb",
            borderRadius: "10px",
            textAlign: "center",
            zIndex: 1000,
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            width: "90%", // Increased width for better alignment
            height: "auto", // Adjust height dynamically
            maxHeight: "none", // No max height to prevent scrolling
          }}
        >
          {submitStatus}
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ width: "100%", height: "auto" }}>
          {/* Name Field */}
          <div className="form-group" style={{ marginBottom: "15px" }}>
            <label
              htmlFor="name"
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "16px",
                color: "#333",
                fontWeight: "bold",
              }}
            >
              Name
            </label>
            <input
              type="text"
              name="name"
              className="form-control"
              id="name"
              placeholder="Your name.."
              required
              value={formData.name}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Email Field */}
          <div className="form-group" style={{ marginBottom: "15px" }}>
            <label
              htmlFor="email"
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "16px",
                color: "#333",
                fontWeight: "bold",
              }}
            >
              Email
            </label>
            <input
              type="email"
              name="email"
              className="form-control"
              id="email"
              placeholder="Your email.."
              required
              value={formData.email}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Subject Field */}
          <div className="form-group" style={{ marginBottom: "15px" }}>
            <label
              htmlFor="subject"
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "16px",
                color: "#333",
                fontWeight: "bold",
              }}
            >
              Subject
            </label>
            <input
              type="text"
              name="subject"
              className="form-control"
              id="subject"
              placeholder="Your subject.."
              required
              value={formData.subject}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Message Field */}
          <div className="form-group" style={{ marginBottom: "15px" }}>
            <label
              htmlFor="message"
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "16px",
                color: "#333",
                fontWeight: "bold",
              }}
            >
              Message
            </label>
            <textarea
              className="form-control"
              name="message"
              id="message"
              rows="5"
              placeholder="Write something.."
              required
              value={formData.message}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            ></textarea>
          </div>

          {/* Submit Button */}
          <div className="text-center" style={{ marginTop: "20px" }}>
            <button
              type="submit"
              style={{
                backgroundColor: "#28a745",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "bold",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
            >
              Submit
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default ContactUs;
